import { Logo } from "assets/svg/logo";
import { theme } from "config";
import styled from "styled-components";

export const FixedLogo = styled(Logo)`
  position: absolute;
  top:      3rem;
  left:     3rem;
  color:    ${props => props.color || theme.palette.blue.main};
`;